import axios, { resHandle } from "@/plugins/axios";
/**
 * @description 获得用户该项目下的数据表格
 * @param vCom Vue
 */
const GetUserDataTable = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("/api/tongue/tables").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 获得舌面分析下的所有数据表格
 * @param vCom Vue
 */
const GetTongueTables = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("/api/tongue/tables").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

/**
 * @description 统计分析：舌图演变规律分析: 参数
 * @param vCom Vue组件
 */
const Getargs = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/tongue/analysis/ybgl/args", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 定性特征分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostDingxingfenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/analysis/dxtz", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 颜色特征参数分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostYansefenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/analysis/ystz", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 几何特征参数分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostJihefenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/analysis/jhtz", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 纹理特征参数分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostWenlifenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/analysis/wltz", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 舌图演变规律分析
 * @param vCom Vue组件
 * @param params 参数
 */
const PostShetufenxi = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/tongue/analysis/ybgl", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};

export {
    GetUserDataTable,
    PostDingxingfenxi,
    PostYansefenxi,
    PostJihefenxi,
    PostWenlifenxi,
    Getargs,
    PostShetufenxi
};
